<template lang="html">
  <div ref="wrap">
    <SectionLabel />

    <SectionHome
      id="home"
      data-id="0"
      :visibilityChanged="visibilityChanged"
    >
      <RevealBlock 
        classList="reveal-margin reveal-top reveal-center"
        imageSrc="grigio.jpg"
      />
      <div class="center">
        <h1 
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {{ $t("message.home_section_1_title") }}
        </h1>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          v-html="$t('message.home_section_1_text_1')"
        ></p>
        <div class="cta-ext"
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          <a :href="$t('message.home_section_1_cta-link')"  v-html="$t('message.home_section_1_cta')" target="_blank">
          </a>
        </div> 
      </div>
      <News 
        data-aos="fade-up"
        data-aos-duration="1000"
        :toggleOpenOverlay="toggleOpenOverlay"
      />
    </SectionHome>

    <SectionHome
      id="who-we-are"
      data-id="1"
      :visibilityChanged="visibilityChanged"
    >
      <div class="center">
        <h2
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {{ $t("message.home_section_2_title") }}
        </h2>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          v-html="$t('message.home_section_2_text_1')"
        ></p>
        
        <h2
          data-aos="fade-up"
          data-aos-duration="1000"
          class="with-margin"
          v-html="$t('message.home_section_2_text_2')"
          ></h2>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          v-html="$t('message.home_section_2_text_3')"
        ></p>
      
        
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          class="certifications--wrap"
        >
        
          <img src="../assets/images/recyclass.png" alt="RecyClass" />
          <img :src="$t('message.image-second-life-01')"  alt="Plastica Seconda Vita" />
          <img :src="$t('message.image-second-life-02')" alt="Plastica Seconda Vita" />
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          class="certifications--wrap-text"
        >
          <p v-html="$t('message.home_section_2-image-desc')"></p>
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          class="certifications--wrap wide--row"
        >
          <img src="../assets/images/logo-pre.jpg" alt="Plastic recyclers europe" />
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          class="certifications--wrap wide--row"
        >
          <img src="../assets/images/conip.png" alt="Conip Logo" />
        </div>
        <br/><br/>
          <h2
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            {{ $t("message.home_section_2_text_4") }}
          </h2>
          <p 
            data-aos="fade-up"
            data-aos-duration="1000"
            v-html="$t('message.home_section_2_text_5')"
          ></p>
          <div
          data-aos="fade-up"
          data-aos-duration="1000"
          class="certifications--wrap full--row"
        >
          <img src="../assets/images/applications.png" alt="Plastic recyclers europe" />
        </div>
          
      </div>

      <div class="video-wrap">
        <div class='embed-container' 
          data-aos="fade-up"
          data-aos-duration="1000">
            <span 
            data-aos="fade-up"
            data-aos-duration="1000"
            v-html="$t('message.home_video_link')"
            >
        </span>
        </div>
      </div>
       
      <RevealBlock 
        classList="reveal-margin"
        imageSrc="00_2x.jpg"
      />
      
           
    </SectionHome>
  
    <SectionHome
      id="our-technology"
      data-id="2"
      :visibilityChanged="visibilityChanged"
    >
      <RevealBlock 
        classList="reveal-margin reveal-top reveal-center"
        imageSrc="our-tech-hero.jpg"
      />
      <div class="center">
        <h2
          data-aos="fade-up"
          data-aos-duration="1000"
        >
          {{ $t("message.home_section_3_title") }}
        </h2>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          class="quote"
          v-html="$t('message.home_section_3_text_1')"
        ></p>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          class="two-cols"
          v-html="$t('message.home_section_3_text_2')"
        ></p>
      </div>
      
      <SliderCarousel />
    </SectionHome>

    <SectionHome 
      id="our-plant"
      data-id="3"
      :visibilityChanged="visibilityChanged"
    >
      
      <div class="center">
        <h2
          data-aos="fade-up"
          data-aos-duration="1000"
          v-html="$t('message.home_section_4_title')"
        >
        </h2>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          class="quote"
          v-html="$t('message.home_section_4_text_1')"
        ></p>
        <p 
          data-aos="fade-up"
          data-aos-duration="1000"
          v-html="$t('message.home_section_4_text_2')"
        ></p>
      </div>
            
    </SectionHome>
    
    
    
    <OverlayNews 
      @toggleOpenOverlay="toggleOpenOverlay"
      :isOpenOverlay="isOpenOverlay"
      :indexNews="indexNews"
    />
  </div>
</template>

<script>
import SectionHome from "../components/shared/SectionHome.vue";
import SectionLabel from "../components/shared/SectionLabel.vue";
import RevealBlock from "../components/shared/RevealBlock.vue";
import News from "../components/shared/News.vue";
import SliderCarousel from "../components/shared/SliderCarousel.vue";
import OverlayNews from "../components/shared/OverlayNews.vue";
import imagesLoaded from "imagesloaded";

export default {
  data() {
    return {
      sectionVisible: null,
      indicators: [],
      isOpenOverlay: false,
      indexNews: 0,
    };
  },
  components: {
    SectionHome,
    SectionLabel,
    News,
    SliderCarousel,
    RevealBlock,
    OverlayNews,
  },
  mounted() {
    window.addEventListener("scroll", this.checkTop);
    let arrayIndicator = document.querySelectorAll(".reveal-label");
    this.indicators = arrayIndicator;
    // Preload images
    let imagestoLoad = this.$refs.wrap.querySelectorAll("img");

    for (var i = 0; i < imagestoLoad.length; i++) {
      imagestoLoad[i].classList.add("blur");
    }
    const preloadImages = () => {
      return new Promise((resolve, reject) => {
        imagesLoaded(imagestoLoad, resolve);
      });
    };

    // And then..
    preloadImages().then(() => {
      // Remove the loader
      for (var i = 0; i < imagestoLoad.length; i++) {
        imagestoLoad[i].classList.remove("blur");
      }
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.checkTop);
  },
  methods: {
    visibilityChanged: function (isVisible, entry) {
      if (isVisible) {
        this.sectionVisible = Number(entry.target.dataset.id);
        let selected = document.querySelector(".reveal-label.scrolled");

        if (selected) selected.classList.remove("scrolled");

        this.indicators[this.sectionVisible].classList.add("scrolled");
      }
    },
    toggleOpenOverlay(index) {
      this.indexNews = index;

      this.isOpenOverlay = !this.isOpenOverlay;
      document.body.classList.toggle("lock");
    },
  },
};
</script>

<style lang="scss" >
#app {
  position: relative;
  width: 100%;
  #home {
    padding-bottom: 180px;
    @media screen and (max-width: 900px) {
      padding-bottom: 100px;
    }
  }
  #our-plant {
    p.quote {
      margin-bottom: 50px;
    }
  }
  #who-we-are {
    p.quote {
      margin-top: 80px;
    }
  }
  .center {
    position: relative;
    margin: 0 25% 0;
    display: flex;
    text-align: left;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    z-index: 1;
    @media screen and( max-width: 1100px) {
      margin: 0 15% 0;
    }
    @media screen and( max-width: 900px) {
      margin: 0 20px 0;
    }
    h1,
    h2 {
      font-size: 60px;
      line-height: 74px;
      padding-bottom: 50px;
      @media screen and(max-width: 900px) {
        font-size: 30px;
        line-height: 37px;
        padding-bottom: 30px;
      }
      &.with-margin {
        margin-top: 80px;
        @media screen and(max-width: 900px) {
          margin-top: 40px;
        }
      }
    }
    p {
      line-height: 30px;
      @media screen and(max-width: 900px) {
        font-size: 14px;
        line-height: 24px;
      }
      a {
        text-decoration: underline;
      }
      &.quote {
        font-size: 26px;
        line-height: 40px;
        font-weight: 700;
        font-style: italic;
        @media screen and(max-width: 900px) {
          font-size: 16px;
          line-height: 24px;
          margin-top: 40px;
        }
      }
      &.two-cols {
        padding: 50px 0;
        column-count: 2;
        @media screen and( max-width:900px) {
          column-count: 1;
        }
      }
    }
    .cta-ext {
      font-size: 24px;
      line-height: 36px;
      margin: 40px 0 0;
      text-decoration: underline;
      font-weight: 700;
      @media screen and( max-width:900px) {
        font-size: 20px;
        line-height: 30px;
        margin: 24px 0 0;
      }
    }
  }
  .pdf-embed {
    position: relative;
    margin-top: 80px;
    margin-bottom: 0;
    padding-top: 60%;
    height: 0;
    width: 100%;
    /* &.pdf-embed-top {
      margin-top: 80px;
      margin-bottom: 0;
    } */
    iframe {
      position: absolute;
      border: none;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
}
.certifications--wrap-text {
  position: relative;
  width: 100%;
  padding: 20px 0 0;
  @media screen and( max-width: 900px) {
    padding: 10px 0 0;
  }
  p {
    font-size: 14px;
    line-height: 20px;
    &.percentage {
      border-bottom: 1px solid;
      font-weight: 700;
      font-size: 24px;
      line-height: 32px !important;
      padding: 80px 0 0;
      @media screen and( max-width: 900px) {
        padding: 40px 0 0;
      }
    }
    @media screen and( max-width: 900px) {
      p {
        font-size: 12px;
        line-height: 16px;
        &.percentage {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }
}
.certifications--wrap {
  position: relative;
  width: 100%;
  display: flex;
  align-content: flex-start;
  justify-content: flex-start;
  padding: 20px 0 0;
  @media screen and( max-width: 900px) {
    padding: 10px 0 0;
  }
  img {
    flex: 0 0 20%;
    align-self: center;
    max-width: 20%;
    margin-right: 30px;
    &:nth-child(2),
    &:nth-child(3) {
      max-width: 20%;
    }
  }
  &.wide--row {
    img {
      flex: 0 0 70%;
      align-self: center;
      max-width: 70%;
    }
  }
  &.full--row {
    img {
      flex: 0 0 100%;
      align-self: center;
      max-width: 100%;
    }
  }
}
.video-wrap {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  margin: 80px 25% 0;
  @media screen and( max-width: 1100px) {
    margin: 80px 15% 0;
  }
  @media screen and( max-width: 900px) {
    margin: 80px 20px 0;
  }
}
.embed-container {
  position: relative;
  overflow: hidden;
  max-width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Home.vue?463fc59c